/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
/* eslint-disable import/first */
/* eslint-disable import/no-extraneous-dependencies */

import 'babel-polyfill';
import Vue from 'vue';

import '@/prototypes/string.prototype';

import router from '@/router';
import store from './store/store';
import { authanticate } from './utils/authenticate.directive';
import { global } from './mixins/global.mixin';
import { nprogress } from '@/plugins/nprogress';
import VueContentLoading from 'vue-content-loading';
import linkify from 'vue-linkify';

Vue.directive('linkified', linkify);
Vue.directive('authenticate', authanticate);
Vue.mixin(global);
Vue.component('VueContentLoading', VueContentLoading);

_.mixin(require("lodash-deep")); // eslint-disable-line
window.introJS = require('intro.js').introJs; // eslint-disable-line

// ------ PLUGINS -------------
import './plugins/bootstrap-vue';
import './plugins/moment';
import './plugins/trumbowyg';
import './plugins/vee-validate';
import './plugins/vue-cookie';
// import './plugins/vue-croppie';
// import './plugins/vue-form-wizard';
// import './plugins/vue-image-upload';
import './plugins/vue-multiselect';
import './plugins/vue-notification';
// import './plugins/vue-sentry';
import './plugins/vue-switches';
import './plugins/vue-the-mask';
import './plugins/vue-touch';

import './style/site.scss';
import 'vue2-animate/dist/vue2-animate.min.css';
import 'material-icons/iconfont/material-icons.css';
import { ObserveVisibility } from 'vue-observe-visibility';

// import VueSocialSharing from 'vue-social-sharing';
// import VueQrcode from '@chenfengyuan/vue-qrcode';
// import VueMarkdown from 'vue-markdown';
import VueJsonLD from 'vue-jsonld';
import VueMeta from 'vue-meta';

// Vue.component('VueMarkdown', VueMarkdown);
import VueGtm from '@gtm-support/vue2-gtm';

Vue.use(VueMeta);
Vue.use(VueJsonLD);
// Vue.use(VueSocialSharing);
// Vue.component(VueQrcode.name, VueQrcode);
Vue.directive('observe-visibility', ObserveVisibility);

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM,
  enabled: false,
  loadScript: true,
  trackOnNextTick: false,
});

Vue.config.productionTip = false;

window.dejavuApp = new Vue({
  nprogress,
  router,
  store,
}).$mount('#app');
